<div class="px-3">
    <div class="rem-text-default mb-6">
        <div class="flex flex-row align-items-center gap-3">
            <div class="rem-bg-light flex items-center justify-center" style="border: 1px solid dimgray; border-radius: 6px;">
                <img src="assets/images/ModelBuilder.png" 
                     alt="Model Icon"
                     class="h-8 object-contain" style="width: 92px;" />
            </div>
            <div style="white-space: nowrap;">
                <div class="text-2xl font-medium">Remitter Super Model Builder</div>
                <div class="mt-1">SQL Table and Poco Model Builder</div>
            </div>
        </div>

        <!-- Top form -->
        <div class="mt-5">
            <div class="form-grid">
                <!-- Row 1 -->
                <span class="p-float-label cell">
                    <input pInputText
                           id="schemaName"
                           [(ngModel)]="schemaName"
                           (ngModelChange)="touch()"
                           class="w-full placeholder-required"
                           placeholder="Schema Name" />
                    <label for="schemaName">Schema Name</label>
                </span>

                <span class="dot cell">.</span>

                <span class="p-float-label cell">
                    <input pInputText
                           id="tableName"
                           [(ngModel)]="tableName"
                           (ngModelChange)="touch()"
                           class="w-full placeholder-required"
                           placeholder="Table Name" />
                    <label for="tableName">Table Name</label>
                </span>


                <!-- Row 2 -->
                <span class="p-float-label cell">
                    <p-dropdown id="tableType"
                                [options]="sqlTableTypes"
                                optionLabel="Name"
                                [(ngModel)]="selectedTableType"
                                (ngModelChange)="touch()"
                                inputId="tableType"
                                class="w-full">
                    </p-dropdown>
                    <label for="tableType">Table Type</label>
                </span>

                <span class="cell"></span>

                <span class="p-float-label cell">
                    <p-dropdown id="sqlRecordOcclusionType"
                                [options]="sqlRecordOcclusionTypes"
                                optionLabel="Name"
                                [(ngModel)]="selectedOcclusionType"
                                (ngModelChange)="touch()"
                                inputId="occlusionType"
                                class="w-full">
                    </p-dropdown>
                    <label for="occlusionType">Record Occlusion</label>
                </span>

                <!-- Row 3: .NET Project Name -->
                <span class="p-float-label cell" style="grid-column: span 3;">
                    <input pInputText id="projectName"
                           [(ngModel)]="projectName"
                           (ngModelChange)="touch()"
                           class="w-full placeholder-required"
                           placeholder="Remitter.Widgets.API" />
                    <label for="projectName">.NET Project Name</label>
                </span>
            </div>
        </div>
    </div>

    <!-- Columns table + buttons section -->
    <div class="table-wrap inline-block align-top mt-4">
        <p-table #dt
                 [value]="columnDefinitions"
                 [tableStyle]="{ 'table-layout': 'auto', 'width': 'auto' }">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width:188px">Name</th>
                    <th style="width:202px">DataType and Size</th>
                    <th class="compact-col">IsNullable</th>
                    <th class="compact-col">IsUnique</th>
                    <th style="width:224px">Default Value</th>
                    <th style="width:252px">Fully Qualified FK</th>
                    <th class="compact-col model-actions-col"></th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-colDef let-ri="rowIndex">
                <tr>
                    <!-- Name -->
                    <td>
                        <input pInputText
                               [(ngModel)]="colDef.Name"
                               (ngModelChange)="touch()"
                               class="placeholder-required"
                               style="width:188px;"
                               placeholder="{FieldName}" />
                    </td>

                    <!-- DataType (required) -->
                    <td>
                        <input pInputText
                               [(ngModel)]="colDef.DataTypeNameWithSize"
                               (ngModelChange)="onTypeInput(colDef, $event)"
                               class="placeholder-required"
                               style="width:202px; text-transform: uppercase;"
                               placeholder="ex: VARCHAR(100), INT etc" />
                    </td>

                    <!-- Nullable -->
                    <td class="compact-cell">
                        <p-checkbox [(ngModel)]="colDef.IsNullable"
                                    (ngModelChange)="touch()"
                                    binary="true">
                        </p-checkbox>
                    </td>

                    <!-- Unique -->
                    <td class="compact-cell">
                        <p-checkbox [(ngModel)]="colDef.IsUnique"
                                    (ngModelChange)="touch()"
                                    binary="true">
                        </p-checkbox>
                    </td>

                    <!-- Default Value (optional) -->
                    <td>
                        <input pInputText
                               [(ngModel)]="colDef.DefaultValue"
                               (ngModelChange)="touch()"
                               class="placeholder-optional"
                               style="width:242px;"
                               placeholder="ex: GETDATE(), 'system', 0 etc" />
                    </td>

                    <!-- Fully Qualified FK (optional) -->
                    <td>
                        <input pInputText
                               [(ngModel)]="colDef.ForeignKeyFullColumnName"
                               (ngModelChange)="touch()"
                               class="placeholder-optional"
                               style="width:252px;"
                               placeholder="ex: Ops.Widget.WidgetId" />
                    </td>

                    <!-- Actions -->
                    <td class="compact-cell">
                        <button pButton
                                icon="pi pi-trash"
                                class="p-button-text p-button-sm text-red-500"
                                (click)="removeColumn(colDef)">
                        </button>
                    </td>
                </tr>
            </ng-template>
        </p-table>

        <!-- Buttons row -->
        <div class="mt-3 flex items-center w-full" style="margin-top: 32px !important;">
            <!-- Left: Add Column -->
            <button pButton label="Add Column" icon="pi pi-plus" (click)="addColumn()" style="margin-left: 10px;"></button>

            <!-- Spacer pushes the next items to the right -->
            <div style="flex-grow: 1;"></div>

            <!-- Right: Template dropdown + Add Template button + matching spacer -->
            <div class="flex gap-3 items-center">
                <span class="p-float-label" style="min-width: 300px;">
                    <p-dropdown id="templatePicker"
                                [options]="sqlColumnTemplates"
                                [(ngModel)]="selectedTemplate"
                                optionLabel="Name"
                                [showClear]="true"
                                [filter]="false"
                                placeholder="Select a template"
                                [style]="{ 'min-width': '300px' }">
                        <ng-template pTemplate="item" let-t>
                            <div>{{ t.Name }}: {{ t.Description }}</div>
                        </ng-template>
                        <ng-template pTemplate="selectedItem" let-t>
                            <div *ngIf="t">{{ t.Name }}: {{ t.Description }}</div>
                            <span *ngIf="!t" class="text-color-secondary">Select a template</span>
                        </ng-template>
                    </p-dropdown>
                    <label for="templatePicker">Template Column</label>
                </span>

                <button pButton
                        label="Add Template Column"
                        icon="pi pi-plus"
                        class="p-button-primary"
                        [disabled]="!selectedTemplate"
                        (click)="addTemplateColumn()">
                </button>

                <!-- This spacer matches the delete icon column width -->
                <div class="model-actions-col"></div>
            </div>
        </div>

        <!-- Table & C# Model Scripts side-by-side -->
        <span class="w-full block mt-6">
            <div class="flex gap-4 w-full items-stretch">
                <!-- Table Create Script -->
                <span class="p-float-label flex-1">
                    <textarea id="tableCreateScript"
                              pInputTextarea
                              [(ngModel)]="tableCreateScript"
                              class="w-full h-full"
                              [autoResize]="false"
                              rows="16"
                              style="font-family: 'Courier';
                                 min-height: 320px;
                                 overflow-x: auto;
                                 white-space: pre;">
                    </textarea>
                    <label for="tableCreateScript">Table Create Script</label>

                    <!-- Copy Button -->
                    <div class="mt-2 flex justify-end">
                        <button pButton
                                label="Copy to Clipboard"
                                icon="pi pi-copy"
                                class="p-button-sm p-button-outlined"
                                (click)="copyToClipboard(tableCreateScript)">
                        </button>
                    </div>
                </span>

                <!-- C# Model Script -->
                <span class="p-float-label flex-1">
                    <textarea id="csharpModel"
                              pInputTextarea
                              [(ngModel)]="csharpModel"
                              class="w-full h-full"
                              [autoResize]="false"
                              rows="16"
                              style="font-family: 'Courier';
                                 min-height: 320px;
                                 overflow-x: auto;
                                 white-space: pre;">
                    </textarea>
                    <label for="csharpModel">C# Model Script</label>

                    <!-- Copy Button -->
                    <div class="mt-2 flex justify-end">
                        <button pButton
                                label="Copy to Clipboard"
                                icon="pi pi-copy"
                                class="p-button-sm p-button-outlined"
                                (click)="copyToClipboard(csharpModel)">
                        </button>
                    </div>
                </span>
            </div>
        </span>
    </div>
</div>
